import { makeStyles, mergeClasses, shorthands } from '@griffel/react';

import type { GriffelClassNames } from '../../../util/classNames';
import { coreuiTokens, tokens } from '../../../util/theme/fluent9';

const useClasses = makeStyles({
  fullWidth: {
    width: '100%',
    maxWidth: 'none',
  },
  primaryBlue: {
    backgroundColor: coreuiTokens.colorBlueBackground3,
    ...shorthands.borderColor('transparent'),
    color: tokens.colorNeutralForegroundOnBrand,

    ':hover': {
      backgroundColor: coreuiTokens.colorBlueBackground3Hover,
      ...shorthands.borderColor('transparent'),
      color: tokens.colorNeutralForegroundOnBrand,
    },

    ':hover:active': {
      backgroundColor: coreuiTokens.colorBlueBackground3Pressed,
      ...shorthands.borderColor('transparent'),
      color: tokens.colorNeutralForegroundOnBrand,
    },
  },
  loadingContent: {
    position: 'relative',
    display: 'inline-flex',
    alignItems: 'center',
  },
  hiddenChildren: {
    visibility: 'hidden',
  },
  centeredSpinner: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
  },
});

export const useClassNames = (
  fullWidth: boolean,
  className: string | undefined,
  isPrimaryBlue: boolean,
  isDisabled: boolean
): GriffelClassNames<'root' | 'loadingContent' | 'hiddenChildren' | 'centeredSpinner'> => {
  const classNames = useClasses();
  const usePrimaryBlueStyles = isPrimaryBlue && !isDisabled;

  return {
    root: mergeClasses(fullWidth && classNames.fullWidth, usePrimaryBlueStyles && classNames.primaryBlue, className),
    loadingContent: classNames.loadingContent,
    hiddenChildren: classNames.hiddenChildren,
    centeredSpinner: classNames.centeredSpinner,
  };
};
